import { t } from "../i18n";

// Kleinanzeigen отверг значение параметра категории («Kein gültiger Wert.»), а
// сервер уже перечитал её варианты (fieldsRefreshed). Сам отказ не говорит, что
// делать дальше, — подсказка говорит.
//
// Отказ приходит от сервера по-русски; известные фразы здесь же переводятся
// (t), чтобы в английской панели не было русского текста.
export const withFieldsRefreshedHint = (message, outcome) => {
  const text = t(String(message || "").trim());
  if (!outcome?.fieldsRefreshed) return text;
  const hint = t("Варианты параметров этой категории обновлены с Kleinanzeigen — выберите отклонённый параметр заново и опубликуйте ещё раз.");
  return text ? `${text}\n${hint}` : hint;
};
